module.exports = __webpack_public_path__ + "static/media/experimentation-large@2x.238a1217.png";